<template>
    <span class="icon-Btn">
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8.937"
        height="15.002"
        viewBox="0 0 8.937 15.002"
        >
        <path
            id="ic_right"
            d="M8.8-8.6a.563.563,0,0,0,0-.8L1.922-16.336a.563.563,0,0,0-.8,0L.2-15.408a.563.563,0,0,0,0,.8L5.752-9,.2-3.389a.563.563,0,0,0,0,.8l.928.928a.563.563,0,0,0,.8,0Z"
            transform="translate(-0.032 16.501)"
            fill="#3a3a3a"
        />
        </svg>
    </span>
</template>
<script>
export default {
    name:"incrementArrowIcon"
}
</script>